/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Modal } from "@material-ui/core";
import Image from "next/image";
import { useWindowResize } from "utils/hooks";

const DownloadAppNudgeModal = ({ open, handleClose }) => {
	const [isMobileView] = useWindowResize();

	return (
		<Modal open={!isMobileView && open}>
			<div className="relative flex h-full w-full items-center justify-center md:static">
				<div className="fixed bottom-0 right-0 z-20 h-auto w-full bg-white p-[24px] md:relative md:max-h-[678px] md:max-w-[688px] md:rounded-[12px]">
					<div className="mx-auto mb-[16px] flex w-[440px] items-center justify-between rounded-[16px] border border-solid border-[#E8E7EA] p-[24px] pb-[8px] shadow-200">
						<div className="flex flex-col">
							<p className="m-0 w-[200px] text-[20px] font-bold leading-[28px] text-[#190A28]">
								Scan the QR to download Apna
							</p>
							<p className="m-0 text-[16px] leading-[24px] text-[#190A28]">
								& get real time job updates
							</p>
							<div className="-ml-2">
								<Image
									loading="lazy"
									width={160}
									height={64}
									objectFit="cover"
									layout="fixed"
									src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
									alt="Get it on google play"
								/>
							</div>
						</div>
						<div className="relative h-[130px] w-[130px] object-cover">
							<Image
								src="/cloudinary/sem_landing_page/Desktop%20Download%20APP%20Modal%20QR%20Code_QR-code.jpeg"
								layout="fill"
							/>
						</div>
					</div>
					<div className="mx-auto w-[440px]">
						<div
							className="w-full cursor-pointer rounded border border-solid bg-[#1F8268] px-[16px] py-[12px] text-center font-semibold text-white"
							onClick={handleClose}
						>
							Done
						</div>
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default DownloadAppNudgeModal;
